module.exports = __webpack_public_path__ + "static/media/login-button.94a756ca.svg";